// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__Z3NJ6","flex":"Hero_flex__u5Wlv","hero-info":"Hero_hero-info__8PTb9","appear":"Hero_appear__vLbXk","flex-blocker":"Hero_flex-blocker__no6Pv"};